import { useEffect } from 'react';
import { atom, useAtom } from 'jotai';
import { useLocation } from 'react-router-dom';
import { Box, ThemeProvider, Typography } from '@mui/material';

import TopBar from '@/components/common/TopBar';
import Sidebar from '@/components/admin/Sidebar';
import { adminTheme } from '@/styles/muiTheme';

// TODO: Change default value after implemented main page
export const titleAtom = atom(window.history.state?.usr?.title ?? '회원 조회');

export default function AdminTemplates({ children }: Readonly<{ children: React.ReactNode }>) {
  const [title, setTitle] = useAtom(titleAtom);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.title) {
      setTitle(location.state.title);
    }
  }, [location.state, setTitle]);

  return (
    <>
      <TopBar />
      <Box sx={{ flexGrow: 1, display: 'flex' }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, position: 'relative', overflow: 'hidden', p: 3 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 3, borderBottom: 1, pb: 1 }}>
            {title}
          </Typography>
          <ThemeProvider theme={adminTheme}>{children}</ThemeProvider>
        </Box>
      </Box>
    </>
  );
}
